module.exports = __webpack_public_path__ + "img/helen_600.c6fa3364.jpg";